export const PHONES = [
  { display: "916 34 54 31", tel: "+34916345431" },
  { display: "676 423 872", tel: "+34676423872" },
];

export const TRANSLATIONS = {
  es: {
    nav: {
      home: "Inicio",
      menu: "Carta",
      official: "Carta oficial",
      reviews: "Reseñas",
      gallery: "Galería",
      contact: "Contacto",
      cart: "Carrito",
      call: "Llamar",
    },
    hero: {
      overline: "Cocina asiática auténtica · Moralzarzal",
      title1: "Restaurante",
      title2: "Q5",
      subtitle: "Sabores que viajan desde Asia hasta tu mesa. Ramen, sushi, baos y wok artesanal en el corazón de la sierra de Madrid.",
      cta1: "Llamar para reservar",
      cta2: "Ver carta",
      scroll: "Descubrir",
    },
    about: {
      overline: "Sobre nosotros",
      title: "Un viaje culinario por Asia",
      p1: "En Restaurante Q5 reinterpretamos la cocina asiática tradicional con respeto por los sabores originales y un toque contemporáneo. Cada plato nace en nuestro wok, cada caldo se cuece durante horas, cada nigiri se moldea a mano.",
      p2: "Llevamos años conquistando paladares en Moralzarzal con una propuesta honesta, generosa y sorprendente.",
      stat1_label: "Valoración Google",
      stat2_label: "Reseñas felices",
      stat3_label: "Platos en carta",
    },
    menu: {
      overline: "Nuestra carta",
      title: "Sabores de la casa",
      subtitle: "Casi 300 platos y bebidas elaborados al momento. Selección completa entre 1,50 € y 28 €.",
      disclaimer: "Estamos terminando de afinar la carta digital · puede contener pequeñas erratas. Las fotografías son orientativas y se han generado con IA: el plato real puede tener una presentación distinta. Para cualquier duda, no dudes en llamarnos.",
      addToCart: "Añadir",
      added: "Añadido al carrito",
      noodleType: "Tipo de fideos",
      noodleWheat: "Harina",
      noodleRice: "Arroz",
      categories: {
        entrantes: "Entrantes & Verdura",
        ramen: "Ramen",
        arroz: "Arroz",
        tallarines: "Tallarines",
        carnes: "Carnes",
        marisco: "Marisco",
        sushi: "Sushi",
        poke: "Poke & Sashimi",
        refrescos: "Refrescos & Aguas",
        cervezas: "Cervezas & Sake",
        vinos: "Vinos (botella)",
        copas_vino: "Copas de Vino",
        cafes: "Cafés & Infusiones",
        cubatas: "Combinados",
        chupitos: "Chupitos",
        cocteles: "Cócteles",
        postres: "Postres",
      },
    },
    officialMenu: {
      overline: "Carta oficial",
      title: "Consulta nuestra carta completa",
      subtitle: "Estos son los originales que verás en mesa. Toca cualquier página para ampliar.",
      open: "Ampliar",
      close: "Cerrar",
    },
    reviews: {
      overline: "Lo que dicen nuestros clientes",
      title: "Experiencias compartidas",
      subtitle: "165 reseñas en Google · 4,6 ★",
    },
    gallery: {
      overline: "Galería",
      title: "Una experiencia para los sentidos",
    },
    call: {
      overline: "Reservas y pedidos",
      title: "Llámanos directamente",
      subtitle: "Para reservar mesa, pedir a domicilio o para recoger, llámanos. Atendemos personalmente cada llamada. También puedes hacer tu pedido o reserva online más abajo.",
      reserve: "Reservar mesa",
      pickup: "Pedido para recoger",
      delivery: "Pedido a domicilio",
      pickupBenefit: "10% de descuento al recoger en local",
      deliveryNote: "Recargo de 2 € por envío",
      deliveryMinIn: "Pedido mínimo 15 € dentro de Moralzarzal",
      deliveryMinOut: "Pedido mínimo 30 € fuera de Moralzarzal",
      deliveryExtraNote: "(en ambos casos sin contar los 2 € del envío)",
      callNow: "Llamar ahora",
      hours: "Atención telefónica en horario de apertura",
    },
    reservation: {
      overline: "Reserva online",
      title: "Reserva tu mesa",
      subtitle: "Rellena el formulario y te confirmamos por teléfono.",
      callNotice: "Tras enviar la solicitud, llámanos para confirmar la disponibilidad.",
      name: "Nombre completo",
      phone: "Teléfono",
      email: "Email (opcional)",
      date: "Fecha",
      time: "Hora",
      guests: "Comensales",
      notes: "Comentarios / Alergias",
      submit: "Enviar solicitud",
      pickDate: "Selecciona una fecha",
      success: "Solicitud recibida. Llámanos al 916 34 54 31 o 676 423 872 para confirmar.",
      error: "Ha habido un problema. Llámanos al 916 34 54 31 o 676 423 872.",
    },
    order: {
      title: "Tu pedido",
      empty: "Tu carrito está vacío.",
      type: "Tipo de pedido",
      delivery: "A domicilio",
      takeout: "Recoger",
      dinein: "Comedor",
      dineinNote: "En mesa",
      dineinHint: "Vas a consumir en el restaurante. Sin coste adicional.",
      pickupDiscount: "-10% al recoger en local",
      deliveryFee: "Envío: +2 €",
      deliveryMin: "Pedido mínimo: 15 € dentro de Moralzarzal · 30 € fuera (sin contar el envío)",
      zonesNotice: "Solo repartimos en Moralzarzal, El Boalo, Cerceda, Mataelpino y Becerril de la Sierra. Fuera de estas zonas no se realiza entrega a domicilio.",
      selectZone: "Selecciona tu localidad",
      name: "Nombre",
      phone: "Teléfono",
      email: "Email (opcional)",
      address: "Dirección de entrega",
      notes: "Notas",
      subtotal: "Subtotal",
      discount: "Descuento (-10%)",
      shipping: "Envío",
      total: "Total",
      submit: "Enviar pedido",
      success: "Pedido recibido. Llámanos al 916 34 54 31 o 676 423 872 para confirmar.",
      error: "No hemos podido procesar el pedido. Llámanos directamente al 916 34 54 31 o 676 423 872.",
      callNotice: "Tras enviar tu pedido, llama a cualquiera de nuestros dos números para confirmar y agilizar la preparación.",
      remove: "Quitar",
      checkout: "Tramitar pedido",
      back: "Seguir comprando",
      minWarning: "El subtotal no llega al mínimo de envío para la zona seleccionada.",
      pickupHint: "¡Te ahorras un 10% recogiendo en local!",
    },
    contact: {
      overline: "Contacto",
      title: "Ven a vernos",
      address: "C. de la Huerta, 27, 28411 Moralzarzal, Madrid",
      phones_title: "Teléfonos",
      hours_title: "Horario",
      hoursOpen: "Jueves a martes · 12:30–16:30 · 20:00–23:30",
      hoursClosed: "Cerrado los miércoles",
      socials: "Síguenos",
    },
    footer: {
      rights: "Todos los derechos reservados.",
      built: "Cocina con alma · Sabor sin fronteras",
    },
    zones: {
      overline: "A domicilio",
      title: "Repartimos solo en estas zonas",
      body: "Servimos a domicilio únicamente en las siguientes localidades cercanas. Fuera de ellas no se realiza entrega — si nos llamas, te confirmamos disponibilidad.",
    },
  },
  en: {
    nav: {
      home: "Home",
      menu: "Menu",
      official: "Official menu",
      reviews: "Reviews",
      gallery: "Gallery",
      contact: "Contact",
      cart: "Cart",
      call: "Call",
    },
    hero: {
      overline: "Authentic Asian Cuisine · Moralzarzal",
      title1: "Restaurante",
      title2: "Q5",
      subtitle: "Flavours that travel from Asia to your table. Handcrafted ramen, sushi, baos and wok in the heart of the Madrid sierra.",
      cta1: "Call to book",
      cta2: "View menu",
      scroll: "Discover",
    },
    about: {
      overline: "About us",
      title: "A culinary journey through Asia",
      p1: "At Restaurante Q5 we reinterpret traditional Asian cuisine with deep respect for original flavours and a contemporary touch. Every dish is born in our wok, every broth simmers for hours, every nigiri is shaped by hand.",
      p2: "For years we've been winning over palates in Moralzarzal with an honest, generous and surprising proposal.",
      stat1_label: "Google Rating",
      stat2_label: "Happy reviews",
      stat3_label: "Menu items",
    },
    menu: {
      overline: "Our menu",
      title: "House flavours",
      subtitle: "Nearly 300 dishes and drinks prepared to order. Full selection from €1.50 to €28.",
      disclaimer: "We are still polishing the digital menu · it may contain small typos. The photos are illustrative and AI-generated: the actual dish may look different. Please call us if you have any doubts.",
      addToCart: "Add",
      added: "Added to cart",
      noodleType: "Noodle type",
      noodleWheat: "Wheat",
      noodleRice: "Rice",
      categories: {
        entrantes: "Starters & Veggies",
        ramen: "Ramen",
        arroz: "Rice",
        tallarines: "Noodles",
        carnes: "Meats",
        marisco: "Seafood",
        sushi: "Sushi",
        poke: "Poke & Sashimi",
        bebidas: "Drinks",
        refrescos: "Soft Drinks & Water",
        cervezas: "Beers & Sake",
        vinos: "Wines (bottle)",
        copas_vino: "Wine by the Glass",
        cafes: "Coffee & Tea",
        cubatas: "Mixed Drinks",
        chupitos: "Shots",
        cocteles: "Cocktails",
        postres: "Desserts",
      },
    },
    officialMenu: {
      overline: "Official menu",
      title: "See our full original menu",
      subtitle: "These are the menus you'll see at the table. Tap any page to enlarge.",
      open: "Enlarge",
      close: "Close",
    },
    reviews: {
      overline: "What our guests say",
      title: "Shared experiences",
      subtitle: "165 Google reviews · 4.6 ★",
    },
    gallery: {
      overline: "Gallery",
      title: "A feast for the senses",
    },
    call: {
      overline: "Bookings & orders",
      title: "Give us a call",
      subtitle: "To book a table, order delivery or pickup, please call us directly. We answer every call personally. You can also place an online order or reservation below.",
      reserve: "Book a table",
      pickup: "Pickup order",
      delivery: "Delivery order",
      pickupBenefit: "10% off when you pick up at the restaurant",
      deliveryNote: "€2 delivery surcharge",
      deliveryMinIn: "Minimum order €15 within Moralzarzal",
      deliveryMinOut: "Minimum order €30 outside Moralzarzal",
      deliveryExtraNote: "(both excluding the €2 delivery fee)",
      callNow: "Call now",
      hours: "Phone attended during opening hours",
    },
    reservation: {
      overline: "Online booking",
      title: "Book your table",
      subtitle: "Fill in the form and we'll confirm by phone.",
      callNotice: "After submitting, please call us to confirm availability.",
      name: "Full name",
      phone: "Phone",
      email: "Email (optional)",
      date: "Date",
      time: "Time",
      guests: "Guests",
      notes: "Comments / Allergies",
      submit: "Send request",
      pickDate: "Pick a date",
      success: "Request received. Call 916 34 54 31 or 676 423 872 to confirm.",
      error: "Something went wrong. Please call 916 34 54 31 or 676 423 872.",
    },
    order: {
      title: "Your order",
      empty: "Your cart is empty.",
      type: "Order type",
      delivery: "Delivery",
      takeout: "Pickup",
      dinein: "Dine-in",
      dineinNote: "At table",
      dineinHint: "You'll enjoy your order at the restaurant. No extra cost.",
      pickupDiscount: "-10% when you pick up",
      deliveryFee: "Delivery: +€2",
      deliveryMin: "Minimum order: €15 inside Moralzarzal · €30 outside (excl. delivery fee)",
      zonesNotice: "We only deliver to Moralzarzal, El Boalo, Cerceda, Mataelpino and Becerril de la Sierra. No delivery outside these areas.",
      selectZone: "Select your town",
      name: "Name",
      phone: "Phone",
      email: "Email (optional)",
      address: "Delivery address",
      notes: "Notes",
      subtotal: "Subtotal",
      discount: "Discount (-10%)",
      shipping: "Delivery",
      total: "Total",
      submit: "Send order",
      success: "Order received. Call 916 34 54 31 or 676 423 872 to confirm.",
      error: "We couldn't process your order. Please call 916 34 54 31 or 676 423 872 directly.",
      callNotice: "After sending your order, call either of our numbers to confirm and speed up preparation.",
      remove: "Remove",
      checkout: "Checkout",
      back: "Keep shopping",
      minWarning: "Your subtotal hasn't reached the minimum for the selected delivery zone.",
      pickupHint: "Save 10% by picking up at the restaurant!",
    },
    contact: {
      overline: "Contact",
      title: "Come visit us",
      address: "C. de la Huerta, 27, 28411 Moralzarzal, Madrid",
      phones_title: "Phones",
      hours_title: "Opening hours",
      hoursOpen: "Thursday to Tuesday · 12:30–16:30 · 20:00–23:30",
      hoursClosed: "Closed on Wednesdays",
      socials: "Follow us",
    },
    footer: {
      rights: "All rights reserved.",
      built: "Soulful cooking · Flavour without borders",
    },
    zones: {
      overline: "Delivery",
      title: "We deliver only to these areas",
      body: "Home delivery is available only to the following nearby towns. Outside these areas we don't deliver — give us a call to confirm.",
    },
  },
};

export const useTranslation = (lang) => TRANSLATIONS[lang] || TRANSLATIONS.es;
